var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import axios from 'axios';
import moment from 'moment-timezone';
import * as React from 'react';
import { matchPath, Route, Switch } from 'react-router-dom';
import { CallbackPage } from './CallbackPage';
import { SilentRenew } from './SilentRenew';
var SecurityRouter = /** @class */ (function (_super) {
    __extends(SecurityRouter, _super);
    function SecurityRouter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SecurityRouter.prototype.render = function () {
        var _this = this;
        // if location is callback page, return only CallbackPage route to allow signin process
        // routes that dont need login
        if (this.props.routesWithNoLogin && !this.isLoginRequired(this.props.location.pathname)) {
            return (React.createElement(Switch, null, this.props.routesWithNoLogin.map(function (route, index) { return (React.createElement(Route, { path: route.path, key: index, exact: route.exact, render: function (props) { return (React.createElement(route.layout, __assign({}, route.layoutProps),
                    React.createElement(route.component, __assign({}, props)))); } })); })));
        }
        // wait for user to be loaded, and location is known
        if (this.props.isLoadingUser) {
            return null;
        }
        // if location is callback page, return only CallbackPage route to allow signin process
        if (this.props.location.pathname === '/callback') {
            return (React.createElement(Switch, null,
                React.createElement(Route, { path: '/callback', component: function () { return React.createElement(CallbackPage, __assign({}, _this.props)); } })));
        }
        // if location is silentrenew, return only SilentRenew
        if (this.props.location.pathname === '/silentrenew') {
            return (React.createElement(Switch, null,
                React.createElement(Route, { path: '/silentrenew', component: function () { return React.createElement(SilentRenew, __assign({}, _this.props)); } })));
        }
        // if user has not been set or is expired, redirect to the Identity Server.
        if (!this.props.user || this.props.user.expired) {
            var redirectUrl = window.location.pathname + window.location.search;
            this.props.userManager.signinRedirect({ data: { path: redirectUrl } });
            return null;
        }
        // this sets the authorization header and base url that will be used for every api call
        axios.defaults.headers.common.Authorization = 'Bearer ' + this.props.user.access_token;
        axios.defaults.headers.common.Pragma = 'no-cache';
        axios.defaults.headers.common.TimeZoneAbbr = moment.tz.guess();
        var keys = Object.keys(localStorage);
        var oidcKey = '';
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            if (key.startsWith('oidc.user')) {
                oidcKey = key;
            }
        }
        axios.interceptors.request.use(function (config) {
            var storageValue = localStorage.getItem(oidcKey);
            var user = JSON.parse(storageValue);
            config.headers.Authorization = 'Bearer ' + user.access_token;
            return config;
        });
        // user is signed in, return all your routes
        return this.props.children;
    };
    SecurityRouter.prototype.isLoginRequired = function (path) {
        var loginRequired = true;
        path = path.toLowerCase();
        for (var _i = 0, _a = this.props.routesWithNoLogin; _i < _a.length; _i++) {
            var route = _a[_i];
            var match = matchPath(path, { path: route.path, exact: true, strict: false });
            if (match) {
                loginRequired = false;
                break;
            }
        }
        return loginRequired;
    };
    return SecurityRouter;
}(React.Component));
export { SecurityRouter };
